var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOneToOne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "one-to-one"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3067",
    "data-name": "Rectangle 3067",
    width: 16,
    height: 16,
    transform: "translate(39 374)",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_377",
    "data-name": "Mask Group 377",
    transform: "translate(-39 -374)",
    clipPath: "url(#one-to-one)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_52_",
    "data-name": "svgexport-6 (52)",
    transform: "translate(39.517 374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4825",
    "data-name": "Group 4825",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9030",
    "data-name": "Path 9030",
    d: "M1.94,6.843h.535a.485.485,0,0,0,.484-.484V5.823a.485.485,0,0,0-.484-.484H1.94a.485.485,0,0,0-.484.484v.535A.485.485,0,0,0,1.94,6.843Zm-.016-1.02a.016.016,0,0,1,.016-.016h.535a.016.016,0,0,1,.016.016v.535a.016.016,0,0,1-.016.016H1.94a.016.016,0,0,1-.016-.016Z",
    transform: "translate(-0.42 0.356)",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9031",
    "data-name": "Path 9031",
    d: "M3.882,6.843h.535A.485.485,0,0,0,4.9,6.359V5.823a.485.485,0,0,0-.484-.484H3.882a.485.485,0,0,0-.484.484v.535A.485.485,0,0,0,3.882,6.843Zm-.016-1.02a.016.016,0,0,1,.016-.016h.535a.016.016,0,0,1,.016.016v.535a.016.016,0,0,1-.016.016H3.882a.016.016,0,0,1-.016-.016Z",
    transform: "translate(-0.291 0.356)",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9032",
    "data-name": "Path 9032",
    d: "M5.823,6.843h.535a.485.485,0,0,0,.484-.484V5.823a.485.485,0,0,0-.484-.484H5.823a.485.485,0,0,0-.484.484v.535A.485.485,0,0,0,5.823,6.843Zm-.016-1.02a.016.016,0,0,1,.016-.016h.535a.016.016,0,0,1,.016.016v.535a.016.016,0,0,1-.016.016H5.823a.016.016,0,0,1-.016-.016Z",
    transform: "translate(-0.162 0.356)",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9033",
    "data-name": "Path 9033",
    d: "M8.3,6.843a.485.485,0,0,0,.484-.484V5.823A.485.485,0,0,0,8.3,5.339H7.765a.485.485,0,0,0-.484.484v.535a.485.485,0,0,0,.484.484Zm-.551-.484V5.823a.016.016,0,0,1,.016-.016H8.3a.016.016,0,0,1,.016.016v.535a.016.016,0,0,1-.016.016H7.765A.016.016,0,0,1,7.749,6.359Z",
    transform: "translate(-0.032 0.356)",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9034",
    "data-name": "Path 9034",
    d: "M10.241,6.843a.485.485,0,0,0,.484-.484V5.823a.485.485,0,0,0-.484-.484H9.706a.485.485,0,0,0-.484.484v.535a.485.485,0,0,0,.484.484ZM9.69,6.359V5.823a.016.016,0,0,1,.016-.016h.535a.016.016,0,0,1,.016.016v.535a.016.016,0,0,1-.016.016H9.706A.016.016,0,0,1,9.69,6.359Z",
    transform: "translate(0.097 0.356)",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9035",
    "data-name": "Path 9035",
    d: "M12.183,6.843a.485.485,0,0,0,.484-.484V5.823a.485.485,0,0,0-.484-.484h-.535a.485.485,0,0,0-.484.484v.535a.485.485,0,0,0,.484.484Zm-.551-.484V5.823a.016.016,0,0,1,.016-.016h.535a.016.016,0,0,1,.016.016v.535a.016.016,0,0,1-.016.016h-.535A.016.016,0,0,1,11.632,6.359Z",
    transform: "translate(0.227 0.356)",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9036",
    "data-name": "Path 9036",
    d: "M1.456,8.3a.485.485,0,0,0,.484.484h.535A.485.485,0,0,0,2.96,8.3V7.765a.485.485,0,0,0-.484-.484H1.94a.485.485,0,0,0-.484.484Zm.469-.535a.016.016,0,0,1,.016-.016h.535a.016.016,0,0,1,.016.016V8.3a.016.016,0,0,1-.016.016H1.94A.016.016,0,0,1,1.925,8.3Z",
    transform: "translate(-0.42 0.485)",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9037",
    "data-name": "Path 9037",
    d: "M3.4,8.3a.485.485,0,0,0,.484.484h.535A.485.485,0,0,0,4.9,8.3V7.765a.485.485,0,0,0-.484-.484H3.882a.485.485,0,0,0-.484.484Zm.469-.535a.016.016,0,0,1,.016-.016h.535a.016.016,0,0,1,.016.016V8.3a.016.016,0,0,1-.016.016H3.882A.016.016,0,0,1,3.866,8.3Z",
    transform: "translate(-0.291 0.485)",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9038",
    "data-name": "Path 9038",
    d: "M5.339,8.3a.485.485,0,0,0,.484.484h.535A.485.485,0,0,0,6.843,8.3V7.765a.485.485,0,0,0-.484-.484H5.823a.485.485,0,0,0-.484.484Zm.469-.535a.016.016,0,0,1,.016-.016h.535a.016.016,0,0,1,.016.016V8.3a.016.016,0,0,1-.016.016H5.823A.016.016,0,0,1,5.808,8.3Z",
    transform: "translate(-0.162 0.485)",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9039",
    "data-name": "Path 9039",
    d: "M1.456,10.241a.485.485,0,0,0,.484.484h.535a.485.485,0,0,0,.484-.484V9.706a.485.485,0,0,0-.484-.484H1.94a.485.485,0,0,0-.484.484Zm.469-.535A.016.016,0,0,1,1.94,9.69h.535a.016.016,0,0,1,.016.016v.535a.016.016,0,0,1-.016.016H1.94a.016.016,0,0,1-.016-.016Z",
    transform: "translate(-0.42 0.615)",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9040",
    "data-name": "Path 9040",
    d: "M3.4,10.241a.485.485,0,0,0,.484.484h.535a.485.485,0,0,0,.484-.484V9.706a.485.485,0,0,0-.484-.484H3.882a.485.485,0,0,0-.484.484Zm.469-.535a.016.016,0,0,1,.016-.016h.535a.016.016,0,0,1,.016.016v.535a.016.016,0,0,1-.016.016H3.882a.016.016,0,0,1-.016-.016Z",
    transform: "translate(-0.291 0.615)",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9042",
    "data-name": "Path 9042",
    d: "M14.415,9.156V2.305a1.271,1.271,0,0,0-1.27-1.27H11.308V.882a.882.882,0,1,0-1.763,0v.154H5.354V.882a.882.882,0,0,0-1.763,0v.154H1.755a1.271,1.271,0,0,0-1.27,1.27V5.978a.234.234,0,0,0,.469,0v-.85H13.947V8.7A4.109,4.109,0,0,0,9.238,8.34V8.259a.494.494,0,0,0-.493-.493H8.227a.494.494,0,0,0-.493.493v.518a.494.494,0,0,0,.425.488,4.1,4.1,0,0,0-.942,2.618c0,.008,0,.016,0,.024H1.755a.8.8,0,0,1-.8-.8V6.916a.234.234,0,0,0-.469,0v5.226a1.271,1.271,0,0,0,1.27,1.27h.567a.234.234,0,1,0,0-.469H1.755a.8.8,0,0,1-.8-.8v-.051a1.264,1.264,0,0,0,.8.285H7.245a4.091,4.091,0,0,0,.109.567h-4.1a.234.234,0,0,0,0,.469H7.51a4.117,4.117,0,1,0,6.905-4.255ZM10.014.882a.413.413,0,0,1,.826,0V2.176a.413.413,0,1,1-.826,0ZM4.06.882a.413.413,0,0,1,.826,0V2.176a.413.413,0,1,1-.826,0ZM1.755,1.5H3.591v.567H3.308a.234.234,0,0,0,0,.469H3.67a.881.881,0,0,0,1.605,0h.362a.234.234,0,0,0,0-.469H5.354V1.5H9.545v.567H9.262a.234.234,0,0,0,0,.469h.362a.881.881,0,0,0,1.605,0h.362a.234.234,0,0,0,0-.469h-.283V1.5h1.837a.8.8,0,0,1,.8.8V3.624H.954V2.305a.8.8,0,0,1,.8-.8Zm-.8,3.155V4.093H13.947v.567ZM8.2,8.259a.025.025,0,0,1,.024-.024h.518a.025.025,0,0,1,.024.024v.405q-.083.066-.163.137H8.227A.025.025,0,0,1,8.2,8.777V8.259Zm3.131,7.272a3.648,3.648,0,1,1,3.648-3.648A3.653,3.653,0,0,1,11.333,15.531Z",
    transform: "translate(-0.485 0)",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9043",
    "data-name": "Path 9043",
    d: "M10.848,8.251a3.082,3.082,0,1,0,3.082,3.082A3.085,3.085,0,0,0,10.848,8.251Zm0,5.695a2.613,2.613,0,1,1,2.613-2.613A2.616,2.616,0,0,1,10.848,13.946Z",
    transform: "translate(0 0.55)",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9044",
    "data-name": "Path 9044",
    d: "M12,11.034h-.58a.755.755,0,0,0-.48-.48v-1.1a.234.234,0,0,0-.469,0v1.1a.752.752,0,1,0,.949.949H12a.234.234,0,0,0,0-.469Zm-1.294.518a.283.283,0,1,1,.283-.283A.284.284,0,0,1,10.7,11.551Z",
    transform: "translate(0.146 0.615)",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.09
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneToOne);
export default __webpack_public_path__ + "static/media/one-to-one.a1cdf7447e77bd74e400ef1a8963c230.svg";
export { ForwardRef as ReactComponent };